var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cartSubtotal)?_c('div',{staticClass:"c-cart-subtotal",class:[
    'l-flex',
    'l-flex--justify-start'
  ]},[_c('h4',{staticClass:"c-cart-subtotal__title t-paragraph-large u-margin-bottom-x-small"},[_vm._v("\n    Subtotal\n  ")]),_vm._v(" "),_c('product-price',{staticClass:"c-cart-subtotal__price",attrs:{"price":_vm.cartSubtotal}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }